import { useIntl, FormattedMessage } from 'react-intl';

import { EmptyState } from '@ets/design-system';

import styles from './Empty.module.scss';

export type EmptyProps = {
  title: TranslationMessage;
  body: TranslationMessage;
};

const Empty = ({ title, body }: EmptyProps) => {
  const intl = useIntl();

  return (
    <EmptyState
      size="l"
      title={intl.formatMessage({
        id: title.id,
      })}
      testId="empty-state"
      description={
        <div className={styles.body}>
          <FormattedMessage id={body.id} />
        </div>
      }
    />
  );
};

export default Empty;
